/**
 * Created by lidhcrt on 11/27/2019.
 */
module.exports = function(app) {
    "use strict";
    app.controller('pages.employer.reports.censusOrWellness', ["$state", "$scope", "sessionData", "services", "invisibleFormService", "employerUtility", "$window","modal", "storage",
        function ($state, $scope, sessionData, services, invisibleFormService, employerUtility, $window, modal, storage) {
            console.log("state Params",$state.params.reportType);
            if($state.params.reportType){
                storage.set('reportType', $state.params.reportType);
                $scope.reportType = $state.params.reportType;
            }
            if(!$state.params.reportType && storage.get('reportType')){
                $scope.reportType = storage.get('reportType');
            }

            var entitlements = sessionData.entitlements;
            var groupAccess = sessionData.employerInfo.planAdministratorEntitlements.groupLevelEntitlements;
            $scope.showSSN = {value: false};
            $scope.timePeriod = { name: 'ND Wellness Taxation Report - Monthly'} ;
            $scope.enableCensusReports = entitlements.reports.CensusReports;
            $scope.enableWellnessReports = entitlements.reports.WellnessReports;
            $scope.errormessage = false;
            $scope.successmessage = false;
            $scope.reportLoading = false;
            $scope.parReport = $scope.reportType === 'wellness';
            $scope.options = [
                {
                    name: 'Excel',
                    value: 'Excel'
                },
                {
                    name: 'PDF',
                    value: 'PDF'
                }
            ];
            $scope.selectedOption = $scope.options[0];
            $scope.$parent.sidebar = {
                breadCrumb: {
                    primary: {
                        title: "Reports",
                        state: "reports"
                    },
                    secondary: {
                        title: $scope.reportType === 'census'? "Census Reports":"Wellness Incentive Taxation Reports"
                    }
                }
            };
            $scope.groupTableObj = {

                order: 'groupNumber',
                reverse: true,
                selectAllRows: false,
                rowSelectionEnabled: true,

                titles: [
                    {
                        name: 'Group Number',
                        dataKey: 'groupNumber'
                    }

                ],
                pagination: {
                    itemsPerPage: 12,
                    page: 1
                },


                groupAccessArray : []
            };

            if (groupAccess) {
                for (var grp in groupAccess) {
                    if (groupAccess.hasOwnProperty(grp)) {
                        var group = {};
                        var current = groupAccess[grp];
                        group.groupNumber = grp;
                        group.selected = false;

                        if ((current['Employee Data'] === 'View' || current['Employee Data'] === 'Modify')) {
                            $scope.groupTableObj.groupAccessArray.push(group);
                        }
                    }
                }

            }
            $scope.$on("update_parent_controller", function(event, message,selectall){
                $scope.message = message;
                $scope.selectAll = selectall;
            });

            $scope.openSuccessModal = function() {
                if($scope.message) {
                    $scope.$broadcast('recieving from reports', $scope.message, $scope.selectAll);
                }


                modal.open({
                               heading:  $scope.reportType === 'census'? 'Select Specific Groups for Census Report':'Select Specific Groups for Wellness Taxation reports',
                               template: require('modals/censusReportSelection.html'),
                               controller: require("../../modals/censusReportSelection"),
                               scope: $scope,
                               classes: 'selected-groups-modal census-large-modal'

                           });

            };




            $scope.onGenerate = function(){
                $scope.reportLoading = true;
                var groupsSelected ;
                if($scope.message && $scope.message.length > 0){
                    groupsSelected = $scope.message.toString();
                }
                else {
                    var fromGroupArray = [];
                    for(var indx = 0;indx<$scope.groupTableObj.groupAccessArray.length;indx++) {
                        fromGroupArray.push($scope.groupTableObj.groupAccessArray[indx].groupNumber);
                    }

                    groupsSelected = fromGroupArray.toString();
                }
                var params = {
                    reportFormat:$scope.selectedOption.value,
                    ssnMask:$scope.showSSN.value === true? 'N' : 'Y',
                    groupNumbersList:groupsSelected
                }

                if($scope.reportType === 'wellness'){
                    params['reportName'] = $scope.timePeriod.name;
                }


                services.eprsvc.censusReport().runCensusReport(params). then(
                    function (response) {
                        $scope.reportLoading = false;
                        if($scope.errormessage){
                            $scope.errormessage = false;
                        }

                        $scope.reports = response.data.payload;
                        $scope.successmessage = true;

                    }, function (error) {
                        $scope.reportLoading = false;
                        if($scope.successmessage){
                            $scope.successmessage = false;
                        }
                        $scope.errormessage = true;
                        console.log("error", error);
                    });




            };

            $scope.resetCensus = function () {
                $scope.message = [];
                $scope.selectedOption = $scope.options[0];
                $scope.selectAll = false;
                $scope.errormessage = false;
                $scope.successmessage = false;
                $scope.showSSN.value = false;
                $scope.timePeriod = { name: 'ND Wellness Taxation Report - Monthly'} ;

            };
        }
    ]);
    return [
        {
            state: 'reports.censusOrWellness',
            url: '/cenOrWell-reports',
            postPassword: true,
            params: {
                reportType : null
            },
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page.html'],
                    controller: 'pages.employer.reports.censusOrWellness'
                },
                'content@reports.censusOrWellness': {
                    templateUrl:'reports/cenOrWell-reports.employerTemplate.html/pages/reports/censusOrWellness'
                    //'reports/requested-reports.employerTemplate.html/pages/reports/requestedReports'
                    //template: require('pages/reports/requestedReports.html')

                }
            }
        }

    ];
};